import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/services/apiClient'

export interface AdapterPersonaBinding {
  persona_id: string
  persona_name: string
  capability_id: string
  credential_set_id: string | null
  credential_set_name: string | null
  source: 'explicit' | 'deployment' | 'none'
  effective_credential_set_name: string | null
}

/**
 * Fetches every persona that binds the given adapter, with
 * credential-set status. Powers the diagnostic panel on the Tool
 * Library Adapter Card (admin-only view).
 */
export function useAdapterPersonas(adapterId: string) {
  return useQuery({
    queryKey: ['adapter-personas', adapterId],
    queryFn: async (): Promise<AdapterPersonaBinding[]> => {
      const res = await apiClient.fetch(`/api/adapters/${adapterId}/personas`)
      if (!res.ok) throw new Error(`Failed to load adapter persona bindings`)
      return res.json()
    },
    enabled: adapterId.length > 0,
  })
}
